import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import api from '../api/axios';

const RefreshButton = () => {
    const [expiresIn, setExpiresIn] = useState(0);

    const fetchTokenInfo = async () => {
        try {
            const res = await api.get('/api/verify');
            setExpiresIn(res.data.expiresIn || 0);
        } catch {
            // Token invalid, let App.js handle redirect
        }
    };

    useEffect(() => {
        fetchTokenInfo();
        const interval = setInterval(fetchTokenInfo, 60000); // Check every 1min
        return () => clearInterval(interval);
    }, []);

    // Auto-refresh warning at 10min
    useEffect(() => {
        if (expiresIn > 0 && expiresIn < 600) { // <10min warning
            const timeout = setTimeout(handleRefresh, expiresIn * 1000 - 300000); // 5min early
            return () => clearTimeout(timeout);
        }
    }, [expiresIn]);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };


    const handleRefresh = async () => {
        try {
            const res = await api.post('/api/refresh', {
                refreshToken: localStorage.getItem('refreshToken')
            });
            localStorage.setItem('token', res.data.accessToken);
            localStorage.setItem('refreshToken', res.data.refreshToken);
            fetchTokenInfo(); // Reset timer
        } catch {
            localStorage.clear();
            window.location.href = '/login';
        }
    };

    if (expiresIn === 0) return null;

    return (
        <Tooltip title="Token auto expires with 5min remaining">
            <Button
                size="small"
                icon={<SyncOutlined spin={expiresIn < 30} />}
                onClick={handleRefresh}
                style={{
                    background: expiresIn >= 600 ? '#d4edda' :        // ≥10min: light green
                        expiresIn < 600  ? '#f8d7da' : undefined,  // <10min: light red
                    color: 'black',                                    // Always black
                    borderColor: expiresIn >= 600 ? '#c3e6cb' :        // Light green border
                        expiresIn < 600  ? '#f5c6cb' : undefined  // Light red border
                }}

            >
                {formatTime(expiresIn)}
            </Button>
        </Tooltip>
    );
};

export default RefreshButton;
